import { useMount, useStates } from '@tiger/hooks';
import { Button } from 'antd';
import qrcode from 'qrcode';
import { Link, useLocation } from 'react-router-dom';
import { CardButtonWrap } from 'components/Card';
import Toast from 'components/Toast';
import Track from 'components/Track';
import iosIcon from 'static/images/icons/apple.png';
import googleIcon from 'static/images/icons/google.png';
import { LocationStatesSuccessNextUrl } from './types';

const iosUrl = 'https://itunes.apple.com/us/app/tradeup-authenticator/id1457192617?mt=8';
const googleUrl = 'https://play.google.com/store/apps/details?id=com.tigerbrokers.security.intl&hl=en';

/**
 * 下载应用页面
 */

const Download: React.FC = () => {
    const [state, setState] = useStates({ iosQrcode: '', androidQrcode: '' });
    const location = useLocation();
    const locationState = location.state as LocationStatesSuccessNextUrl | null;
    const genQrcode = async () => {
        try {
            const iosQrcode = await qrcode.toDataURL(iosUrl, { margin: 0 });
            const androidQrcode = await qrcode.toDataURL(googleUrl, { margin: 0 });

            setState({
                iosQrcode,
                androidQrcode
            });
        } catch (e) {
            Toast.show(e);
        }
    };

    useMount(() => {
        genQrcode();
    });

    return (
        <div className="install-step install-step-download">
            <h3 className="text-left">{__('Download the TradeUP Authenticator')}</h3>
            <p className="text-left">
                {__(
                    'Please search for TradeUP Authenticator from the App Store (iOS) or Google Play (android). Or you can scan the QR code to install the App directly.'
                )}
            </p>
            <div className="qrcode">
                <div className="qrcode-item">
                    <img src={state.iosQrcode} className="qrcode-img" alt="iOS" />
                    <a href={iosUrl} className="qrcode-link">
                        <img src={iosIcon} className="qrcode-link-icon" alt="app store" />
                        App Store
                    </a>
                </div>
                <div className="qrcode-item">
                    <img src={state.androidQrcode} className="qrcode-img" alt="Android" />
                    <a href={googleUrl} className="qrcode-link">
                        <img src={googleIcon} className="qrcode-link-icon" alt="google play" />
                        Google Play
                    </a>
                </div>
            </div>
            <Track eventModel="安全中心" eventType="两步验证_开启" eventName="我已下载">
                <Link to="../2" state={locationState}>
                    <CardButtonWrap>
                        <Button size="large" block type="primary">
                            {__('我已下载，下一步')}
                        </Button>
                    </CardButtonWrap>
                </Link>
            </Track>
        </div>
    );
};

export default Download;
